import { Alert, Box, Snackbar, Typography } from '@mui/material';
import { snackBar } from './keywordOverview/keywordOverviewCSS';
import { useDispatch, useSelector } from 'react-redux';
import { setOpenSearchCreditModal } from 'src/redux/keywordResearch';
import { RootState } from 'src/redux/store';
import { setIsOpenChangePlan } from 'src/redux/siteAuditReducer';
import { paths } from 'src/common/config/TextMessage';
import { useNavigate } from 'react-router';

const CommonKeywordSnackBar = ({ open, handleClose }) => {
  const dispatch = useDispatch();
  let userDetails: any =
    useSelector((state: RootState) => state.counter.userDetails) ?? {};
  const isMember = userDetails?.role_type === 'member';
  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  const isDIY = activePlanName === planDetails.diy || activePlanName === planDetails.starterPlus;
  const isEnterprise = activePlanName === planDetails.enterprise;
  const navigate = useNavigate();
  return (
    <>
      <Snackbar
        sx={{ marginTop: '2.8rem' }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        <Box>
          <Alert
            severity="error"
            variant="filled"
            sx={{ ...snackBar?.alertError }}
            onClose={handleClose}
          >
            {
              'You have used up all your search credits, you can buy a new package of credits to gain access.'
            }
            {!isMember && !isEnterprise && (
              <Typography
                sx={{
                  cursor: 'pointer'
                }}
                onClick={() => {
                  if (isDIY) {
                    dispatch(setIsOpenChangePlan(true));
                    navigate(paths?.billing);
                  } else {
                    dispatch(setOpenSearchCreditModal(true));
                  }
                }}
              >
                {'Get more searches'}
              </Typography>
            )}
          </Alert>
        </Box>
      </Snackbar>
    </>
  );
};
export default CommonKeywordSnackBar;
